/** A span of a text, as UTF-16 indices like Y.Text: from inclusive, to exclusive. */
export interface TextSpan {
  readonly from: number;
  readonly to: number;
}

/** Text deltas without the hidden span, retaining each delta's attributes. */
export function revealedDeltas<T extends { insert: string }>(
  deltas: readonly T[],
  hidden: TextSpan | undefined
): T[] {
  if (hidden === undefined) return [...deltas];
  const visible: T[] = [];
  let index = 0;
  for (const delta of deltas) {
    const start = index;
    index += delta.insert.length;
    const cutFrom = Math.min(
      Math.max(hidden.from - start, 0),
      delta.insert.length
    );
    const cutTo = Math.min(Math.max(hidden.to - start, 0), delta.insert.length);
    if (cutFrom >= cutTo) {
      visible.push(delta);
      continue;
    }
    const insert = delta.insert.slice(0, cutFrom) + delta.insert.slice(cutTo);
    if (insert) visible.push({ ...delta, insert });
  }
  return visible;
}
